// extracted by mini-css-extract-plugin
export default {"formContainer":"Login_formContainer__+cTTV","title":"Login_title__SJ0Uv","error":"Login_error__SdyqE"};